import React, { useEffect, useState } from "react";
import logo from "../img/logo.jpeg";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/about" },
    { name: "Included", href: "/include" },
    { name: "Caregivers", href: "/CareGiver" },
    { name: "How It Works", href: "/howItWork" },
    { name: "FAQs", href: "/faq" },
    { name: "Get Certified", href: "/getCertified" },
  ];

  return (
    <header className="w-full shadow-sm sticky top-0 z-50 bg-white">
      {/* Top Bar */}
      <div className="bg-[#2FB57C] lg:block hidden h-[40px] text-white text-sm px-2">
        <div className="max-w-7xl p-2 mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-center sm:text-left">
          <div className="flex items-center gap-2 justify-center sm:justify-start">
            <FaMapMarkerAlt className="flex-shrink-0" />
            <span className="truncate text-[14px]">
              Hampton Reserve Drive, Brentwood Tennessee, 37027
            </span>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 justify-center">
            <div className="flex items-center gap-1">
              <FaEnvelope className="flex-shrink-0" />
              <span>
                <a href="mailto:Edu@AngelWatch.org">Edu@AngelWatch.org</a>
              </span>
            </div>
            <div className="flex items-center gap-1">
              <FaPhoneAlt className="flex-shrink-0" />
              <span>
                <a href="tel:+18003816794">+1 800-381-6794</a>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div
        style={{ padding: "7px" }}
        className="max-w-7xl mx-auto flex items-center justify-between sm:py-4"
      >
        {/* Logo */}
        <div className="flex items-center">
          <a href="/">
            <img src={logo} alt="Logo" className="w-[120px]" />
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-4 xl:space-x-6 font-medium text-black">
          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="hover:text-[#2FB57C] transition whitespace-nowrap px-1 text-[14px] xl:text-base"
            >
              {item.name}
            </a>
          ))}
          <div className="hidden lg:block">
            <a href={`${process.env.REACT_APP_ADMIN_URL}/login`} className="bg-yellow-500 text-white font-semibold px-4 py-1.5 sm:px-5 sm:py-2 rounded-full hover:bg-yellow-600 transition text-sm sm:text-base">
              Login/Register
            </a>
          </div>
        </nav>

        {/* Tablet Menu Button */}
        <div className="hidden md:flex lg:hidden items-center">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-gray-700 focus:outline-none flex items-center gap-1"
            aria-label="Toggle Menu"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={
                  menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"
                }
              />
            </svg>
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-gray-700 focus:outline-none"
            aria-label="Toggle Menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={
                  menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"
                }
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Tablet/Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="lg:hidden px-4 pb-2 space-y-2 bg-white border-t shadow-md">
          <div className="grid grid-cols-1 gap-x-3  font-medium text-black">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="hover:text-blue-600 py-2 text-sm sm:text-base"
              >
                {item.name}
              </a>
            ))}
          </div>
      
            <a
              href={`${process.env.REACT_APP_ADMIN_URL}/login`}
              className="block w-full cursor-pointer mt-2 bg-yellow-500 text-white text-center py-2 rounded-md hover:bg-yellow-600 transition"
            >
              Login/Register
            </a>
          
        </div>
      )}
    </header>
  );
}
